<app-template [title]="conference?.title" [subTitle]="conference?.subtitle" [fullLayout]="true" [footerVisible]="true">
  <div class="conference-map-container">
    <div class="cards-container">
      <div class="card-item" *ngFor="let locality of conference?.localities">
        <h2 tabindex="0">{{locality?.name}}</h2>
        <div class="line"></div>
        <ul role="none">
          <li role="button" tabindex="0" *ngFor="let children of locality?.children" class="locality-child" (click)="selectRegional(children)">
            {{children.name}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</app-template>
